module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAAeElEQVQYV2WNIQ6DUBQE5zX0Jxg4HZIj4LkDF6ih3ABSS3AVNRg8BoWoIRiSQv9rSEOg6drZ2RUNMLNP+FYqN6XjENEIb55IUBSoz5abZDzXzg43Q1kU7mYk/4erAe1gufxAhV4shbnSfGcD3JdHfILSSXkI2O3hA5P0MLuCM/XUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/icon_sj_orange.png
// module id = 766
// module chunks = 1